import type { ExtractPropTypes, PropType } from 'vue';
import type Drawer from './drawer.vue';

export const DrawerProps = {
  modelValue: {
    type: Boolean,
    default: false,
    required: true,
  },
  appendToBody: {
    type: Boolean,
    default: true,
  },
  lockScroll: {
    type: Boolean,
    default: true,
  },
  // 关闭前的回调，会暂停 Drawer 的关闭
  beforeClose: Function as PropType<(done: (cancel?: boolean) => void) => void>,
  closeOnClickModal: {
    type: Boolean,
    default: false,
  },
  closeOnPressEscape: {
    type: Boolean,
    default: false,
  },
  openDelay: Number,
  closeDelay: Number,
  destroyOnClose: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  direction: {
    type: String as PropType<'rtl' | 'ltr' | 'ttb' | 'btt'>,
    default: 'rtl',
  },
  showClose: {
    type: Boolean,
    default: false,
  },
  size: {
    type: [String, Number],
    default: '50%',
  },
  modalClass: {
    type: String,
  },
  zIndex: {
    type: Number,
    default: 1000,
  },
  title: {
    type: String,
    default: '',
  },
  /**
   * 自定义属性
   */
  // 是否使用默认滚动条
  // 即高度撑开时自动显示滚动条
  hasScrollbar: {
    type: Boolean,
    default: true,
  },
  // 是否预留顶部空间
  // 在中台使用时，为了不让抽屉挡住导航栏，会留顶部空间56px
  overTop: {
    type: Boolean,
    default: true,
  },
};

export type DrawerPropsType = ExtractPropTypes<typeof DrawerProps>;
export type DrawerInstance = InstanceType<typeof Drawer>;
